export default "__VITE_ASSET__D_Ma1MZk__"